export { default as es } from './es';
export { default as en } from './en';
export { default as zh } from './zh';
//# sourceMappingURL=index.js.map